module.exports = {
	attributes: [],
	roles: [],
	permissions: [],
	users: [],
};
